import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';
import * as routes from '../../constants/routes';
// Pages
import PhoneCapturePage from '../../pages/PhoneCapturePage';
import SnapFlowPage from '../../pages/SnapFlowPage';
import BookingPage from '../../pages/BookingPage';
import MyBookingsPage from '../../pages/MyBookingsPage';
import ProductLandingPage from '../../pages/ProductLandingPage';
import RSVPPage from '../../pages/RSVPPage';
import QRScannerPage from '../../pages/QRScannerPage';
import NftPage from '../../pages/NftPage';
import NftMiaPage from '../../pages/NftMiaPage';

import { AppWrapper, BodyWrapper } from '../styles';

const RootLayout = () => (
  <AppWrapper>
    <Router>
      <Switch>
        <Route exact path={routes.PRODUCT_LANDING_PAGE}>
          <ProductLandingPage />
        </Route>

        <Route exact path={routes.FORM_CAPTURE_PAGE}>
          <PhoneCapturePage />
        </Route>

        <Route path={routes.QR_SCANNER_PAGE} component={QRScannerPage} />
        <Route exact path={routes.SNAPFLOW_PAGE} component={SnapFlowPage} />

        <Route exact path={[routes.BOOKING_PAGE, routes.BOOKING_SERVICE_PAGE]}>
          <BookingPage />
        </Route>

        <Route path={routes.RSVP_PAGE} component={RSVPPage} />
        <Route exact path={routes.NFT_ITEM} component={NftPage} />
        <Route exact path={routes.NFT_MIA} component={NftMiaPage} />

        <Route exact path={routes.MY_BOOKINGS_PAGE}>
          <MyBookingsPage />
        </Route>

        <Route path={routes.APP_ROOT}>
          <BodyWrapper>
            <h1>SnapCall</h1>
          </BodyWrapper>
        </Route>
      </Switch>
    </Router>
  </AppWrapper>
);

RootLayout.defaultProps = {};

RootLayout.propTypes = {};

export default RootLayout;
